const React = require('react');

const {AdminTrxRouting} = require('../../../dumb/AdminHelpers/AdminTrx/');

const TrxTable = require('./components/TrxTable');
const PaymentsTable = require('./components/PaymentsTable');
const ReconTable = require('./components/ReconTable');
const ReserveTable = require('./components/ReserveTable');
const TrxDetails = require('./components/TrxDetails');
const {ThirdLayerMenu} = require("../../../dumb/AdminHelpers/AdminLayout");
const {paramStore} = require("../../../../stores");
const withState = require("../../../../utils/withState");

const config$ = paramStore('tableType');


const Trx = () => (
  <AdminTrxRouting
    views={{
      table: TrxTable,
      details: TrxDetails
    }}
  />
);

const Payments = () => (
  <AdminTrxRouting
    views={{
      table: PaymentsTable,
      details: TrxDetails
    }}
  />
);

module.exports = withState((setState, self, onMount) => {
  return ({currentTab}) => {
    const links = [
      {
        id: 'payments',
        title: 'Payments List'
      },
      {
        id: 'transactions',
        title: 'Transactions List'
      },
      {
        id: 'reserve',
        title: 'Rolling Reserve'
      },
      {
        id: 'reconciliation',
        title: 'Nuvei Reconciliation'
      }
    ];
    const views = {
      payments: Payments,
      transactions: Trx,
      reserve: ReserveTable,
      reconciliation: ReconTable,
    }

    const View = views[currentTab] ? views[currentTab] : views[links[0].id];

    return (
      <>
        <ThirdLayerMenu
          emitter={config$}
          links={links}
        />
        <div className="mt20">
          <View />
        </div>
      </>
    );
  }
}, {
  currentTab: config$
})
